import { makeStyles } from '@material-ui/core';

const styles = makeStyles(() => ({
  root: {
    marginBottom: 16,
    '& > .MuiGrid-item': {
      paddingBlock: 4,
    },
    '& .MuiGrid-item': {
      paddingInline: 8,
    },
  },
  header: {
    width: 150,
  },
  chip: {
    width: 80,
    '&.Disponible': { backgroundColor: '#D3E5E3' },
    '&.Suspendido': { backgroundColor: '#BEC6CD' },
    '&.Apartado': { backgroundColor: '#F6D086' },
    '&.Vendido': { backgroundColor: '#409A8E', color: 'white'  },
  },
}));

export default styles;